import '../../styles/styles.css';

import { useState } from 'react';
import { InView } from 'react-intersection-observer';

import Layout from '../../components/Layout';
import AnimateIn from '../../components/AnimateIn';
import YMHelmet from '../../components/YMHelmet';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Company = ({featuredProjectsList}) => {
  const [currentTheme, setTheme] = useState('dark');
  return (
    <Layout
      useDarkTheme={true}
      metaData={{ data: { title: 'Company' } }}
      featuredProjectsList={featuredProjectsList}
    >
      <section className="components page theme__section--dark">
        <AnimateIn className="text g-row">
          <div>Company</div>
          <YMHelmet />
          <h1>
            Your Majesty is home to a constantly growing set of powerful ideas
            to move the human experience forward. Our place is a front seat to
            creating the future of digital experiences with pioneering brands
            and people.
          </h1>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <p>
            Founded ten years ago by three Swedes with the conviction to create
            great work driven by equally great people.
          </p>
          <p>
            Your Majesty is today a thriving design and technology firm with
            offices in New York and Amsterdam.
          </p>
          <a
            className="tertiary-link"
            href="https://medium.com/your-majesty-co/our-tale-9b23baa1c0a3"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read Our Tale on <em>Medium</em> &rarr;
          </a>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2>Testament</h2>
          <p>
            200+ awards including Innovative Site of the Year, Cannes Lions, Jay
            Chiat Awards, JD Powers, The Webby Awards, CLIO Awards, Creativity
            Awards, Art Directors Club, AICP/MoMA permanent collection, The One
            Show, New York Festivals, Pixel Awards, Awwwards, The FWA, Commarts
            and Andy Awards.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2>As seen in</h2>
          <p>
            Wired, Fast Company, The New York Times, Quartz, Mashable, Engadget,
            Condé Nast Traveler, Popular Mechanics, PSFK, High Snobiety and
            Hypebeast{' '}
          </p>
          <div className={'icon icon-apple'}>
            <svg
              width="77"
              height="88"
              viewBox="0 0 77 88"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M74.03125,29.359375 C70.1874808,32.0312634 67.5742257,34.7148303 66.1914062,37.4101562 C64.8085868,40.1054822 64.1171875,43.0234218 64.1171875,46.1640625 C64.1171875,48.6484499 64.5273396,50.9218647 65.3476562,52.984375 C66.1679729,55.0468853 67.3281175,57.003897 68.828125,58.8554688 C70.3281325,60.7070405 72.8359199,62.5468659 76.3515625,64.375 C74.9921807,68.3593949 72.8828268,72.4257605 70.0234375,76.5742188 C67.1640482,80.722677 64.5742304,83.6640538 62.2539062,85.3984375 C59.9335821,87.1328212 57.7187605,88 55.609375,88 C53.9218666,88 51.6484518,87.4609429 48.7890625,86.3828125 L47.453125,85.890625 L45.2734375,84.9765625 C43.7265548,84.5078102 42.0156344,84.2734375 40.140625,84.2734375 C38.2187404,84.2734375 36.062512,84.6953083 33.671875,85.5390625 L31.984375,86.171875 L29.875,87.015625 C28.1874916,87.6718783 26.5000084,88 24.8125,88 C21.2499822,88 17.4297079,85.5039312 13.3515625,80.5117188 C9.27341711,75.5195063 6.19141668,70.1523725 4.10546875,64.4101562 C2.01952082,58.66794 0.9765625,52.8672168 0.9765625,47.0078125 C0.9765625,39.4608998 3.1210723,33.1797126 7.41015625,28.1640625 C11.6992402,23.1484124 17.5234007,20.640625 24.8828125,20.640625 C27.5547009,20.640625 30.0624883,21.1328076 32.40625,22.1171875 L34.0234375,22.75 L35.7109375,23.453125 C37.210945,24.062503 38.4062455,24.3671875 39.296875,24.3671875 C40.6093816,24.3671875 41.9218684,24.1093776 43.234375,23.59375 L45.484375,22.75 L47.1015625,22.1171875 C49.7265756,21.1328076 52.6327966,20.640625 55.8203125,20.640625 C63.3672252,20.640625 69.437477,23.5468459 74.03125,29.359375 Z M56.171875,0.6015625 C56.2656255,1.63281766 56.3125,2.42968469 56.3125,2.9921875 C56.3125,5.89845203 55.4687584,8.89842203 53.78125,11.9921875 C52.0937416,15.085953 49.8906386,17.4882727 47.171875,19.1992188 C44.4531114,20.9101648 41.4531414,21.765625 38.171875,21.765625 C38.0312493,20.6406194 37.9609375,19.8203151 37.9609375,19.3046875 C37.9609375,16.8203001 38.6992114,14.207045 40.1757812,11.4648438 C41.6523511,8.72264254 43.6562373,6.39063461 46.1875,4.46875 C48.7187627,2.54686539 51.5781091,1.32812758 54.765625,0.8125 C55.0468764,0.765624766 55.5156217,0.695312969 56.171875,0.6015625 Z"
                fill-rule="evenodd"
              />
            </svg>
          </div>
          <p>
            Editors’ Choice &nbsp;·&nbsp; Best new app
            <br />
            Apple.com frontpage takeover feature.
          </p>
        </AnimateIn>
      </section>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Company;
